import type { FaireProductEntity } from "../../entity_types/product";

export const p_7mcha2zfbq: FaireProductEntity = {
  token: "p_7mcha2zfbq",
  type: "product",
  name: "Spice and Wolf, Vol. 11",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/9bf00ed3b780c3b1412429363fb7455b814b464fd3054d2bbe26e3ca3ce4cf21.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8e44c69d5d61a0642cc3f283834646ac616d3c55298ba6470636e42723f439f8.jpeg"
  ],
  priceDollars: 6.5,
  description: "Parental Advisory: Explicit Content Warning\n\nScheming abounds in Kerube, and the fate of the entire town hangs in the balance! Lawrence has gotten swept up in machinations--again--and this time he's not even sure which side he's on. With Holo's help, he's going to have to see through the lies to discover the truth of the plans surrounding the narwhal, and if he fails, not only will crucial information about Holo's homeland slip through his fingers, but the merchant woman Eve could pay the ultimate price! This manga adaptation of Isuna Hasekura's acclaimed Spice & Wolf novel series, also available from Yen Press, is an investment that promises the greatest of entertainment returns!",
  tags: [],
  msrpDollars: 13,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:06:32.212Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
